export const environment = {
  production: true,
  platformUrl: 'https://apps.skolaro.com',
  appApiServer: 'https://api-workflow-v2.skolaro.com',
  jwtCookieDomain: '.skolaro.com'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts